export default "__VITE_ASSET__BrPXEvci__"